var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"name","placeholder":"Search...","options":_vm.shops},on:{"search":_vm.onSearch},model:{value:(_vm.selectedShop),callback:function ($$v) {_vm.selectedShop=$$v},expression:"selectedShop"}},[_c('template',{slot:"no-options"},[_vm._v(" Start typing to search for a shop ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }